/**
 * Theme API client
 *
 * Provides functions for managing story themes:
 * - Get current theme
 * - Save/update theme
 * - Generate theme from context
 */

import { api } from './client';

export const themeApi = {
  /**
   * Get current theme for a story
   * @param {string} storyId - Story UUID
   * @returns {Promise<{data: {theme: string|null, updated_at: string|null}}>}
   */
  getTheme: (storyId) => api.get(`/stories/${storyId}/theme`),

  /**
   * Save/update a story's theme
   * @param {string} storyId - Story UUID
   * @param {string} theme - Theme text to save
   * @returns {Promise<{data: {theme: string, updated_at: string}}>}
   */
  saveTheme: (storyId, theme) => api.put(`/stories/${storyId}/theme`, { theme }),

  /**
   * Generate a theme from available story context
   * Does NOT automatically save - returns for user review
   * @param {string} storyId - Story UUID
   * @param {string|null} sessionId - Optional workshop session ID for context
   * @returns {Promise<{data: {generated_theme: string, warning: string|null}}>}
   */
  generateTheme: (storyId, sessionId = null) =>
    api.post(`/stories/${storyId}/theme/generate`, { session_id: sessionId })
};
